import { useMemo } from 'react'
import { Select } from 'antd'
import { ICONS, iconForKey } from '@/components/icons/registry'

export const Icon = ({ iconKey, fallback = 'file' }: { iconKey?: string | null; fallback?: 'file' | 'folder' | 'appstore' }) => {
  const key = ICONS.has(iconKey ?? '') ? iconKey! : fallback
  const Component = iconForKey(key, fallback)
  return <span className="configuration-icon" data-icon-key={key} aria-hidden="true"><Component /></span>
}
const OPTIONS = Array.from(ICONS, ([value, entry]) => ({ value,
  label: <span className="configuration-icon-option"><Icon iconKey={value} /><span>{entry.label}</span></span>, search: entry.label + ' ' + value }))

export const IconPicker = ({ value, onChange, disabled, id }: {
  value?: string | null; onChange?: (value: string | undefined) => void; disabled?: boolean; id?: string;
}) => {
  const options = useMemo(() => value && !ICONS.has(value)
    ? [...OPTIONS, { value, label: <span>{value}</span>, search: value }] : OPTIONS, [value])
  return <Select id={id} value={value || undefined} onChange={onChange} options={options} disabled={disabled}
    allowClear showSearch optionFilterProp="search" placeholder="未配置" className="configuration-icon-picker" />
}
